import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import Image from 'partials/Image';
import Html from 'partials/Html';
import SmartLink from 'partials/SmartLink';
import Container from 'partials/Container';
import css from 'css';
import Slider from 'partials/Slider';


class IntroImage extends Component {

    constructor(props) {
        super(props);
        
        const { data } = this.props;
        this.imageData = data.background_type === 'multiple' ? data.images[Math.floor(Math.random()*data.images.length)].image : data.image;

    }


    render() {
        const { data } = this.props;
        console.log('IntroImage:', data);
        return(
            <div>
                <ModuleWrapper>
                    {data.background_type !== 'slider' ? (
                        <Image image={this.imageData} ratio="16:9" background minHeight="480px" />
                    ) : (
                        <Slider
                            initialSlide={Math.floor(Math.random()*data.images.length)}
                            slides={data.images.map(image =>
                                <React.Fragment>
                                    {image.project_link !== "" &&
                                        <SmartLink to={image.project_link} className="project-link"/>
                                    }
                                    <Image image={image.image} ratio="16:9" background minHeight="480px" />
                                </React.Fragment>
                            )}
                            autoPlay
                            autoplayInterval={8500}
                            withBullets
                            effect="fade"
                            kenBurns
                        />
                    )}
                    <Overlay opacity={data.overlay_opacity} />
                    <TextLayer descOnRight={data.description_placement === 'right'}>
                        <Container>
                            <h2><Html>{data.title}</Html></h2>
                            <Description descOnRight={data.description_placement === 'right'}>
                                <Html>{data.description}</Html>
                                {data.link.url &&
                                    <SmartLink to={data.link.url} target={data.link.target}>{data.link.title}</SmartLink>
                                }
                            </Description>
                        </Container>
                    </TextLayer>
                </ModuleWrapper>
                <MobileDescription>{data.description}</MobileDescription>
            </div>
        );
    }
}

export default withRouter(IntroImage);

const ModuleWrapper = styled.div`
    position:relative;
    @media (max-width: 768px) {
        margin-left:-15px;
        margin-right:-15px;
    }
`

const Overlay = styled.div`
    pointer-events: none;
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    background: #000;
    opacity: .${props => props.opacity || 0};
    z-index: 2;
`

const TextLayer = styled.div`
    pointer-events: none;
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    padding: 80px 0;
    z-index: 3;

    @media (max-width: 960px) {
        padding: 50px 0;
    }

    @media (max-width: 768px) {
        padding: 35px 15px;
    }
    
    > div {
        display:flex;
        ${props => props.descOnRight ? `
            justify-content: space-between;
            flex-direction: row;
            padding-top:10px;
            @media (max-width: 768px) {
                flex-direction: column;
                justify-content: flex-start;
            }
        ` : `
            flex-direction: column;
            justify-content: flex-start;
        `}
    }

    h2 {
        font-size:43px;
        font-family: ${css.fonts.bg_bold};
        color:#fff;
        margin: 0 0 40px;
        width:40%;
        line-height:50px;
        @media (max-width: 960px) {
            font-size:40px;
            line-height:1.2;
        }
        @media (max-width: 768px) {
            font-size:30px;
            width:100%;
            margin: 0 0 30px;
        }
        @media (max-width:480px) {
            font-size: 26px;
            line-height: 31px;
        }
    }
`

const Description = styled.div`
    font-size:14px;
    color: #fff;
    width:40%;
    font-family: ${css.fonts.bg_regular};

    ${props => props.descOnRight ? `
        font-size:24px;
        width:52%;
    ` : ``}

    @media (max-width: 768px) {
        width:100%;
    }

    > div {
        margin-bottom:40px;
        @media (max-width: 768px) {
            display:none;
        }
    }

    a {
        color:#fff;
        font-family: ${css.fonts.bg_regular};
        font-size:18px;
    }
`

const MobileDescription = styled(Html)`
    padding: 25px;
    background: #fff;
    display:none;
    @media (max-width: 768px) {
        display:block;
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/IntroImage.js